<template>
  <app-layout :heading="$t('heading')">
    <employees-overview/>
  </app-layout>
</template>
<script>
import EmployeesOverview from '@/components/routes/employees/EmployeesOverview'

export default {
  name: 'EmployeesOverviewView',
  components: { EmployeesOverview },
  i18n: {
    messages: {
      en: {
        heading: 'Employees overview'
      },
      de: {
        heading: 'Mitarbeiterübersicht'
      },
      ru: {
        heading: 'Обозор сотрудников'
      },
      tr: {
        heading: 'Çalışanlara genel bakış'
      }
    }
  }
}
</script>
